import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { translate } from '@repo/phrase';
import type { Command } from '@sp-saljapro/command-menu';
import { useRegisterCommands } from '@sp-saljapro/command-menu/react';

import { MODAL } from '@/components/modals/asset-modal.types';

import { type GuardPendingChanges, runGuardedAction } from '@/hooks/asset-pending-changes-navigation.hooks';
import { trackCommand } from '@/utils/command-menu.utils';
import { getAppConfig } from '@/utils/window.utils';

export const useAssetViewCommands = (_guardPendingChanges: GuardPendingChanges = runGuardedAction) => {
    const { setActiveModal } = useAssetActionModalStore();
    const config = getAppConfig();
    const commandMenuEnabled = config.feature.commandMenu?.enable;
    const group = translate('command_menu_orders_group_actions');

    const commands: Command[] = [
        {
            id: 'asset:message',
            keys: ['M'] as const,
            description: translate('command_menu_messages'),
            group,
            onSelect: (source) => {
                trackCommand('asset:message', source);
                setActiveModal(MODAL.MESSAGE);
            },
        },
        {
            id: 'asset:share',
            keys: ['P'] as const,
            description: translate('command_menu_share'),
            group,
            onSelect: (source) => {
                trackCommand('asset:share', source);
                setActiveModal(MODAL.SHARE);
            },
        },
        {
            id: 'asset:export',
            keys: ['R'] as const,
            description: translate('command_menu_export'),
            group,
            onSelect: (source) => {
                trackCommand('asset:export', source);
                setActiveModal(MODAL.EXPORT);
            },
        },
    ];

    useRegisterCommands({
        enabled: commandMenuEnabled,
        commandKey: commands.map((command) => command.id),
        commands,
    });
};
